import React, { Component, useState, useEffect, useRef } from "react";
import Form from "react-jsonschema-form";
import { withRouter, useLocation, useHistory, useParams, Link } from 'react-router-dom';
import { useSelector } from "react-redux";

import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';

import { customFormats, transformErrors } from "common/validation";
// import { faFacebookF, faTwitter } from "@fortawesome/free-brands-svg-icons";
// import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// import logo from "images/logo/product.jpg";
// import icLogo from "images/logo/IITMIC_Logo_small.png";
// import biLogo from "images/logo/bioincubator.png";
// import mtiLogo from "images/logo/mti.png";
// import rtbiLogo from "images/logo/rtbi.png";
import iccrLogo from "images/logo/iccrr-logo.png";
import gyan from "images/logo/gyan.jpg";
import cloneDeep from 'lodash.clonedeep';
import { axiosApi } from "../../common/httpService";
import "ic.css";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { notifier } from "common";

import fields from "react-jsonschema-form-extras";
import CFormFields from "common/Form/CFormFields";
import { INDIAN_STATES_UNION_TERRITORIES } from "../../properties/client";

import {selectAppType} from "common/appSlice";

let allFields = Object.assign({}, fields, CFormFields);

const rolid = "";

const additionalMetaSchemas = require("ajv/lib/refs/json-schema-draft-04.json");
const schema = {
  type: "object",
  required: ["username", "password"],
  properties: {
    username: {
      type: "string",
      title: "User name",
    },
    password: {
      type: "string",
      title: "Password",
    },
  },
};

const uiSchema = {
  password: {
    "ui:widget": "password",
    "ui:placeholder": "Password",
    "ui:options": {
      label: false,
    },
  },
  username: {
    "ui:placeholder": "Username",
    "ui:autofocus": true,
    "ui:options": {
      label: false,
    },
  },
};
const formdata = {
  username: "",
  password: "",
};




const signupformdata = {
  username: "",
  password: "",
  firstname: undefined,
  lastname: "",
  dateofbith: "",
  genderid: "",
  mailid: "",
  contactno: "",
  adharnumber: "",
  passportnumber: "",
  statename: "",
  uploadlink1: "",
  uploadlink2: undefined,
  uploadlink3: undefined,
  uploadlink4: undefined,
  uploadlink5: undefined,
  genreid: "",
  // categoryid: "",
  newgenrename: "",
  newcategoryname: "",
  declared: false,
  captcha: "",
}

class LoginFormComponent extends Component {
  constructor(props) {
    super(props);
    // this.state = {
    //   modal: false,
    // };
    this.toggle = this.toggle.bind(this);
    this.handleSignupModalOpened = this.handleSignupModalOpened.bind(this);
    this.generateOTP = this.generateOTP.bind(this);
    this.getGenreIdForValue = this.getGenreIdForValue.bind(this);
    this.getCategoryIdForValue = this.getCategoryIdForValue.bind(this);
    this.addsignup = this.addsignup.bind(this);
    this.captchaRef = React.createRef();
    this.state = {
      signupschema: {
        type: "object",
        required: ["username", "firstname", "dateofbith", "uploadlink1", "contactno", "adharnumber", "statename", "genreid", "declared", "captcha"],
        properties: {
          username: {
            type: "string",
            title: "Email ID (User Name)",
            format: "userdetemailid",
            maxLength: 256,
          },
          //password: {
          //  type: "string",
          //  title: "Password",
          //  format: "userdetpassword",
          //},
          firstname: {
            type: "string",
            title: "First Name",
            format: "userdetfirstname",
          },
          lastname: {
            type: "string",
            title: "Last Name",
            format: "userdetlastname",
          },
          dateofbith: {
            type: "string",
            title: "D.O.B",
            format: "date",
          },
          genderid: {
            title: "Gender",
            enum: [],
            enumNames: [],
          },
          //mailid: {
          //  type: "string",
          //  title: "Email ID",
          //  format: "userdetemailid",
          //  maxLength: 256,
          //},
          contactno: {
            type: "string",
            title: "Contact Number",
            format: "userdetcontactnumber",
            maxLength: 15,
          },
          adharnumber: {
            type: "string",
            title: "Aadhar Number",
            format: "aadhar",
            maxLength: 15,
          },
          passportnumber: {
            type: "string",
            title: "Passport Number",
            format: "passportIndia",
          },
          statename: {
            title: "State",
            type: "string",
          },
          uploadlink1: {
            type: "string",
            title: "Upload Link 1",
            format: "url",
          },
          uploadlink2: {
            type: "string",
            title: "Upload Link 2",
            format: "url",
          },
          uploadlink3: {
            type: "string",
            title: "Upload Link 3",
            format: "url",
          },
          uploadlink4: {
            type: "string",
            title: "Upload Link 4",
            format: "url",

          },
          uploadlink5: {
            type: "string",
            title: "Upload Link 5",
            format: "url",
          },
          genreid: {
            title: "Genre Name",
            type: "string",
            format: "nonEmptyString",
          },
          // categoryid: {
          //   title: "Category Name",
          //   type: "string",
          //   format: "nonEmptyString",
          // },
          declared: {
            type: "boolean",
            title: "Declaration: The particulars given above are true to the best of my  knowledge and belief. I have been given to understand that my information submitted to the ICCR herewith shall  be used for registration to ICCR's Artist Management System.",
            default: false,
          },
          captcha: {
            type: "string",
            title: "CAPTCHA",
          },
        },
      },
      signupuiSchema: {
        //password: {
        //  "ui:widget": "password",
        //  "ui:placeholder": "Password",
        //  // "ui:options": {
        //  //   label: false,
        //  // },
        //},
        username: {
          "ui:placeholder": "Username",
          "ui:autofocus": true,
          // "ui:options": {
          //   label: false,
          // },
        },
        firstname: {
          "ui:placeholder": "Firstname",
          "ui:autofocus": true,
          // "ui:options": {
          //   label: false,
          // },
        },
        lastname: {
          "ui:placeholder": "Lastname",
          "ui:autofocus": true,
          // "ui:options": {
          //   label: false,
          // },
        },
        dateofbith: {
          "ui:placeholder": "D.O.B",
          "ui:autofocus": true,
          // "ui:options": {
          //   label: false,
          // },
        },
        genderid: {
          // "ui:placeholder": "Gender",
          "ui:autofocus": true,
          // "ui:options": {
          //   label: false,
          // },
        },
        //mailid: {
        //  "ui:placeholder": "EmailID",
        //  "ui:autofocus": true,
        //  // "ui:options": {
        //  //   label: false,
        //  // },
        //},
        contactno: {
          "ui:placeholder": "Contact Number",
          "ui:autofocus": true,
          // "ui:options": {
          //   label: false,
          // },
        },
        adharnumber: {
          "ui:placeholder": "Aadhar Number",
          "ui:autofocus": true,
        },
        passportnumber: {
          "ui:placeholder": "Passport Number",
          "ui:autofocus": true,
        },
        statename: {
          "ui:field": "typeahead",
          typeahead: {
            id: "statename",
            options: [...INDIAN_STATES_UNION_TERRITORIES],
            placeholder: "Choose a State...",
            minLength: 0,
            disabled: false,
          },
        },
        uploadlink1: {
          "ui:placeholder": "Upload Link 1",
          "ui:autofocus": true,
        },
        uploadlink2: {
          "ui:placeholder": "Upload Link 2",
          "ui:autofocus": true,
        },
        uploadlink3: {
          "ui:placeholder": "Upload Link 3",
          "ui:autofocus": true,
        },
        uploadlink4: {
          "ui:placeholder": "Upload Link 4",
          "ui:autofocus": true,
        },
        uploadlink5: {
          "ui:placeholder": "Upload Link 5",
          "ui:autofocus": true,
        },
        genreid: {
          "ui:field": "typeahead",
          typeahead: {
            id: "genreid",
            allowNew: true,
            newSelectionPrefix: "Add a new Genre: ",
            options: [],
            placeholder: "Choose a Genre...",
            //highlightOnlyResult: true,
            minLength: 0,
            disabled: false,
          },
        },
        // categoryid: {
        //   "ui:field": "typeahead",
        //   typeahead: {
        //     id: "categoryid",
        //     allowNew: true,
        //     newSelectionPrefix: "Add a new Category: ",
        //     options: [],
        //     placeholder: "Choose a Category...",
        //     //highlightOnlyResult: true,
        //     minLength: 0,
        //     disabled: false,
        //   },
        // },
        declared: {
        },
        captcha: {
          "ui:placeholder": "CAPTCHA",
          "ui:autofocus": true,
          "ui:options": {
            label: false,
          },
        },
        "ui:field": "layout_grid",
        "ui:layout_grid": {
          "ui:row": [
            {
        "ui:col": {
          md: "12",
          children: [
            {
              "ui:row": [
                { "ui:col": { md: "3", children: ["username"] } },
                { "ui:col": { md: "3", children: ["firstname"] } },
                { "ui:col": { md: "3", children: ["lastname"] } },
                { "ui:col": { md: "3", children: ["dateofbith"] } },
              ],
            },
            {
              "ui:row": [
                { "ui:col": { md: "3", children: ["genderid"] } },
                { "ui:col": { md: "3", children: ["contactno"] } },
                { "ui:col": { md: "3", children: ["adharnumber"] } },
                { "ui:col": { md: "3", children: ["passportnumber"] } },
              ],
            },
            {
              "ui:row": [
                { "ui:col": { md: "4", children: ["statename"] } },
                { "ui:col": { md: "4", children: ["genreid"] } },
                // { "ui:col": { md: "4", children: ["categoryid"] } },
                { "ui:col": { md: "4", children: ["uploadlink1"] } },
              ],
            },
            {
              "ui:row": [
                { "ui:col": { md: "3", children: ["uploadlink2"] } },
                { "ui:col": { md: "3", children: ["uploadlink3"] } },
                { "ui:col": { md: "3", children: ["uploadlink4"] } },
                { "ui:col": { md: "3", children: ["uploadlink5"] } },
              ],
            },
            {
              "ui:row": [
                { "ui:col": { md: "12", children: ["declared"] } },
              ],
            },
            {
              "ui:row": [
                { "ui:col": { md: "3", children: ["captcha"] } },
              ],
            },
          ],
        },
            },
          ],
        },
      }

    }

  }

  componentDidMount() {
    if (this.captchaRef.current) {
      loadCaptchaEnginge(6);
    }
    this.props.history.replace(this.props.fromLocation);
  }

  toggle() {

    axiosApi.post(`/auth/getGenre`, {

    })
      .then((response) => {
        if (response.status === 200 && response.data.statusCode === 0) {
          const tempUISchema = cloneDeep(this.state.signupuiSchema);
          tempUISchema.genreid.typeahead.options = response.data.rows.map(row => { return { "id": row.id, "label": row.value } });
          this.setState({ signupuiSchema: tempUISchema });
        } else {
          console.error(response);
        }
      })
      .catch((error) => {
        console.error(error);
      });


    axiosApi.post(`/auth/getCategory`, {

    })
      .then((response) => {
        if (response.status === 200 && response.data.statusCode === 0) {
          const tempUISchema = cloneDeep(this.state.signupuiSchema);
          //tempUISchema.categoryid.typeahead.options = response.data.rows.map(row => { return { "id": row.id, "label": row.value } });
          this.setState({ signupuiSchema: tempUISchema });
        } else {
          console.error(response);
        }
      })
      .catch((error) => {
        console.error(error);
      });
    this.setState({
      modal: !this.state.modal,
    });

    axiosApi.post(`/auth/getGenderdetails`, {

    })
      .then((response) => {
        if (response.status === 200 && response.data.statusCode === 0) {
          const tempSchema = cloneDeep(this.state.signupschema);
          const roles = response.data.rows.map(row => ({
            id: row.id, // Assuming the value contains role IDs
            value: row.value, // Assuming the label contains role names
          }));
          console.log("----roles", roles)
          tempSchema.properties.genderid.enum = roles.map(role => role.id);
          tempSchema.properties.genderid.enumNames = roles.map(role => role.value);
          console.log("----enum", tempSchema.properties.genderid.enum);
          console.log("----enumNames", tempSchema.properties.genderid.enumNames);
          this.setState({ signupschema: tempSchema });
        } else {
          console.error(response);
        }
      })
      .catch((error) => {
        console.error(error);
      });

  };

  generateOTP = () => {
    return '123456';  //TODO: remove test code
    let digits = '0123456789';
    let OTP = '';
    let len = digits.length
    for (let i = 0; i < 6; i++) {
      OTP += digits[Math.floor(Math.random() * len)];
    }

    return OTP;
  };

  getGenreIdForValue = (inputValue) => {
    let matchedItem = [...this.state.signupuiSchema.genreid.typeahead.options.filter((item) => item.label === inputValue)];
    return (matchedItem.length > 0) ? matchedItem[0].id : undefined;
  };

  getCategoryIdForValue = (inputValue) => {
    let matchedItem = [...this.state.signupuiSchema.categoryid.typeahead.options.filter((item) => item.label === inputValue)];
    return (matchedItem.length > 0) ? matchedItem[0].id : undefined;
  };

  addsignup(formData) {

    let userName = formData.username;
    let passWord = this.generateOTP();
    let firstName = formData.firstname;
    let lastName = formData.lastname || "";  // Mandatory in backend
    let mailID = userName;
    let contactNo = formData.contactno;
    let adharnumber = formData.adharnumber;
    let passportnumber = formData.passportnumber;
    let statename = formData.statename;
    let uploadlink1 = formData.uploadlink1;
    let uploadlink2 = formData.uploadlink2 || undefined;
    let uploadlink3 = formData.uploadlink3 || undefined;
    let uploadlink4 = formData.uploadlink4 || undefined;
    let uploadlink5 = formData.uploadlink5 || undefined;
    let genreid = this.getGenreIdForValue(formData.genreid);
    let newgenrename = (genreid === undefined) ? formData.genreid : undefined;
    // let categoryid = this.getCategoryIdForValue(formData.categoryid);
    // let newcategoryname = (categoryid === undefined) ? formData.categoryid : undefined;
    let genderid = formData.genderid;
    let dob = formData.dateofbith;
    axiosApi
      .post('/auth/signup', {
        userdetloginname: userName, userdetpassword: passWord, userdetfirstname: firstName,
        userdetlastname: lastName, userdetemailid: mailID, userdetcontactnumber: contactNo, operationDoneBy: "ADMIN",
        genreid: genreid, categoryid: 12, adharnumber: adharnumber, passportnumber: passportnumber, statename: statename, uploadlink1: uploadlink1, uploadlink2: uploadlink2, uploadlink3: uploadlink3, uploadlink4: uploadlink4, uploadlink5: uploadlink5, newgenrename: newgenrename,
        newcategoryname: "", genderid: genderid,dob
        // userdetnote: null, userdetadminstate: null, userdetsystemuser: null, userdetauthmethod: null,operationDoneBy:"ADMIN"
      })
      .then((response) => {
        console.log("resp:::::::::::", response);
        if (response.data.status === 'Failure') {
          notifier.error(response.data.message);
        } else {
          notifier.success(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
        notifier.error(error);
      });

  };


  handleSubmit = ({ formData }, options) => {
    console.log("form Data:::::::::::::", formData);
    if (formData) {
      this.addsignup(formData);
      // this.addArtProfile(formData);
    }
    this.toggle();
  };

  handleSignupModalOpened = () => {
    if (this.captchaRef.current) {
      loadCaptchaEnginge(6);
    }
  };

  render() {
    return (
      <div className={this.props.loginType === "aims" ? "login-page login-background-aims" : ((this.props.loginType === "ams") ? "login-page login-background-ams" : "login-page login-background")}>
        <div className="login-header">
        </div>
        <div className="offset-md-7 login-box-body login-box-body-custom">
          <div className="login-form-custom">
            <Form
              idPrefix={"loginForm"}
              schema={schema}
              uiSchema={uiSchema}
              formData={formdata}
              onSubmit={(e) => this.props.handleLogin(e.formData, this.props)}
              customFormats={customFormats}
              transformErrors={transformErrors}
              showErrorList={false}
              noHtml5Validate={true}
              additionalMetaSchemas={[additionalMetaSchemas]}
            >
              <div className="col-sm-12 text-center" style={{ marginTop: "-5%", marginBottom: "3%" }}>
                {/* <LoadCanvasTemplateNoReload /> */}
              </div>
              <div className="col-sm-12">
                <button
                  type="submit"
                  className="btn btn-primary btn-sm text-center"
                  style={{ "width": "200px" }}
                >
                  Login
                </button>
              </div>
            </Form>
            {(this.props.loginType === "ams") ? (
              <div className="col-sm-12" style={{ marginTop: "1rem" }}>
                <button
                  type="submit"
                  className="btn btn-primary btn-sm text-center"
                  style={{ "width": "200px" }}
                  onClick={this.toggle}
                >
                  Artist Signup
                </button>
              </div>
            ) : (
              <div></div>
            )}
            <div>
              <Modal
                isOpen={this.state.modal}
                toggle={this.toggle}
                className={"modal-lg striped blue"}
                onOpened={this.handleSignupModalOpened}
              >
                <ModalHeader toggle={this.toggle}> Artist Registration </ModalHeader>
                <ModalBody>
                  <small>
                  <Form
                    schema={this.state.signupschema}
                    uiSchema={this.state.signupuiSchema}
                    fields={allFields}
                    autocomplete="on"
                    formData={signupformdata}
                    customFormats={customFormats}
                    transformErrors={transformErrors}
                    noHtml5Validate={true}
                    showErrorList={false}
                    liveValidate={true}
                    onSubmit={(e) => {
                      if (!e.formData.declared) {
                        notifier.error('Please Accept the Declaration');
                        return;
                      }
                      if (!validateCaptcha(e.formData.captcha)) {
                        notifier.error('Invalid CAPTCHA');
                        return;
                      }
                      this.handleSubmit(e, this.props)
                    }}
                  >
                    <div className="row justify-content-center align-items-center">
                    <div className="col-sm-8 align-self-center" style={{ marginTop: "-9%", marginBottom: "3%", marginLeft: "10%" }}>
                      <LoadCanvasTemplateNoReload ref={this.captchaRef} />
                    </div>
                    </div>
                    <div className="row justify-content-center align-items-center">
                    <div className="col-sm-4 align-self-center">
                      <button
                        type="submit"
                        className="btn btn-primary btn-sm text-center"
                        style={{width: "100%"}}
                      >
                        Register
                      </button>
                    </div>
                    </div>
                  </Form>
                  </small>
                </ModalBody>
              </Modal>
            </div>
          </div>

        </div>
        {/*
        {(this.props.loginType === "scholarships") && (
	  <div className="offset-md-5 login-box-body login-box-body-custom">
            <div className="row justify-content-center align-items-center" style={{ "width": "400px" }}>
              <div className="col-sm-5 align-self-center">
                <a href="#/aimslogin" className="btn btn-primary text-center">To Login as <b>AIMS</b> user click here...</a>
              </div>
              <div className="col-sm-2 align-self-center">
              </div>
              <div className="col-sm-5 align-self-center">
                <a href="#/artistlogin" className="btn btn-primary text-center">To Login as <b>Artist</b> click here...</a>
              </div>
            </div>
          </div>
        )}
        */}
      </div>
    );
  }
}


const LoginForm = (props) => {
  const loginFormCompRef = useRef();
  const location = useLocation();
  const appType = useSelector(selectAppType);

  const getLoginType = (argFromLocation, argAppType) => {
    if (argAppType == null) {
      switch (argFromLocation) {
	case '/login':
	  return 'scholarships';
	case '/aimslogin':
	  return 'aims';
	case '/artistlogin':
	  return 'ams';
	default:
	  return 'scholarships';
      }
    } else {
      return argAppType;
    }
  };
  const [loginType, setLoginType] = useState(getLoginType(props.fromLocation, appType));

  useEffect(() => {
    setLoginType(getLoginType(props.fromLocation, appType));
  }, [props.fromLocation, appType]);

  useEffect(() => {
    if ((location !== undefined) && (location.pathname !== undefined) && (location.pathname.includes('login'))) {
      if (loginFormCompRef.current !== null) {  // set login location only when the component visible
        localStorage.setItem("iccrLoginLocationPathname", location.pathname);
      }
    }
  }, [location]);

  return <LoginFormComponent ref={loginFormCompRef} location={location} {...props} loginType={loginType}/>
}


export default LoginForm;
